__turbopack_context__.v({
  "link": "styles-module__uBe56G__link",
});
